// Remove commas
export const unformatNumber = (val) => val.replace(/,/g, "");

// Format with Indian comma style (lakh format)
export const formatCTC = (val) => {
  if (!val) return "";

  const num = val.toString().replace(/,/g, "");

  return new Intl.NumberFormat("en-IN").format(num);
};

export const formatDateTimeU = (dateString, options = {}) => {
  if (!dateString) return options.split ? { date: "-", time: "-" } : "-";

  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  const dateObj = isDateOnly ? new Date(dateString + "T00:00:00") : new Date(dateString);

  if (isNaN(dateObj.getTime())) return options.split ? { date: "-", time: "-" } : "-";

  const formattedDate = dateObj.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const formattedTime = dateObj.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  if (options.split) {
    return { date: formattedDate, time: isDateOnly ? "-" : formattedTime };
  }

  return isDateOnly ? formattedDate : `${formattedDate}, ${formattedTime}`;
};